export const CLOSE_SETTINGS = "@layout/CLOSE_VISUALIZATION_SETTINGS";
export const OPEN_SETTINGS = "@layout/OPEN_VISUALIZATION_SETTINGS";
